import { render, staticRenderFns } from "./activityAudit.vue?vue&type=template&id=5f5fbf87&scoped=true&"
import script from "./activityAudit.vue?vue&type=script&lang=js&"
export * from "./activityAudit.vue?vue&type=script&lang=js&"
import style0 from "./activityAudit.vue?vue&type=style&index=0&id=5f5fbf87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fbf87",
  null
  
)

export default component.exports